<template>
  <el-menu>
    <template v-for="(item, index) in menuList">
      <el-menu-item
        v-if="!item.sonMenu"
        :class="{ click: isClick == item.menuId }"
        @click="tab_change(item.name, item.menuId)"
        :key="index"
      >
        <i :class="getMenuIcon(item.menuId) + ' el-num'"></i>
        <span slot="title">{{ item.name }}</span>
      </el-menu-item>
      <el-submenu v-if="item.sonMenu" :key="item.menuId" :index="item.menuId">
        <template slot="title">
          <i :class="getMenuIcon(item.menuId) + ' el-num'"></i>
          <span
            @click="tab_change(item.name, item.menuId)"
            :class="{ click: item.menuId == isClick }"
            >{{ item.name }}</span
          >
        </template>
        <el-menu-item-group
          v-for="sonMenu in item.sonMenu"
          :key="sonMenu.menuId"
        >
          <el-menu-item
            :class="{ click: isClick == sonMenu.menuId }"
            :index="sonMenu.menuId"
            @click="tab_change(sonMenu.name, sonMenu.menuId)"
            >{{ sonMenu.name }}
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
    </template>
  </el-menu>
</template>
<script>
import { mapState } from "vuex";
import { clearG, setGstore, getGstore } from "../utils/storage";

export default {
  data() {
    return {
      isClick: "",
      // 根据环境配置不同的菜单ID映射
      menuIdMap: this.getMenuIdMap(),
    };
  },
  mounted() {
    if (this.$store.state.menuList == 0) {
      this.$store.state.menuList = localStorage.list;
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(menuList) {
        const whiteList = ["/addGood", "/orderDetail"];
        if (whiteList.indexOf(menuList.path) > -1) {
          return (this.$store.state.isTable = false);
        }
        this.$nextTick(() => {
          if (localStorage.menu_id) {
            this.tab_change(localStorage.menu_name, localStorage.menu_id);
          } else {
            this.tab_change(
              this.$store.state.menuList[0].name,
              this.$store.state.menuList[0].menuId
            );
          }
        });
      },
    },
  },

  methods: {
    // 获取环境对应的菜单ID映射
    getMenuIdMap() {
      const isDevelopment = process.env.VUE_APP_NODE === 'development' || process.env.NODE_ENV === 'development';
      
      if (isDevelopment) {
        // 开发环境菜单ID映射 (44-48)
        return {
          certification: 44,        // 认证管理
          certificationSuccess: 45, // 认证成功
          certificationFail: 46,    // 认证失败
          feedBack: 47,             // 反馈管理
          certificationCancel: 48   // 认证取消
        };
      } else {
        // 生产环境菜单ID映射 (36-40)
        return {
          certification: 36,        // 认证管理
          certificationSuccess: 37, // 认证成功
          certificationFail: 38,    // 认证失败
          feedBack: 39,             // 反馈管理
          certificationCancel: 40   // 认证取消
        };
      }
    },

    tab_change(name, id) {
      console.log("-------------", id);
      this.isClick = id;
      this.$store.state.pageTitle = name;
      //为了text组件可以正常显示
      this.$store.state.isTable = true;

      setGstore("menu_id", id);
      setGstore("title", name);
      setGstore("menu_name", name);
      switch (id) {
        case 6:
          this.$router.push({
            path: `/org`,
          });
          break;
        case 7:
          this.$router.push({
            path: `/per`,
          });
          break;
        case 8:
          this.$router.push({
            path: `/app`,
          });
          break;
        case 9:
          this.$router.push({
            path: `/t`,
          });
          break;
        case 10:
          this.$router.push({
            path: `/pan`,
          });
          break;
        case 11:
          this.$router.push({
            path: `/assets`,
          });
          break;
        case 12:
          this.$router.push({
            path: `/short`,
          });
          break;
        case 13:
          this.$router.push({
            path: `/task`,
          });
          break;
        case 14:
          this.$router.push({
            path: `/c`,
          });
          break;
        case 15:
          this.$router.push({
            path: `/i`,
          });
          break;
        case 16:
          this.$router.push({
            path: `/v`,
          });
          break;
        case 18:
          this.$router.push({
            path: `/admin`,
          });
          break;
        case 19:
          this.$router.push({
            path: `/actor`,
          });
          break;
        case 20:
          this.$router.push({
            path: `/org_table`,
          });
          break;
        case 21:
          this.$router.push({
            path: `/user_table`,
          });
          break;
        case 24:
          this.$router.push({
            path: `/publish`,
          });
          break;
        case 25:
          this.$router.push({
            path: `/publish`,
          });
          break;
        case 26:
          this.$router.push({
            path: `/banner`,
          });
          break;
        case 28:
          this.$store.state.texts_status = -1;
          this.$router.push({
            path: `/tools_f`,
          });
          break;
        case 29:
          this.$store.state.texts_status = -1;
          this.$router.push({
            path: `/tools_app`,
          });
          break;
        case 31:
          this.$router.push({
            path: `/shopHome`,
          });
          break;
        case 32:
          this.$router.push({
            path: `/transactionManage`,
          });
          break;
        case 33:
          this.$router.push({
            path: `/goodsManage`,
          });
          break;
        case 34:
          this.$router.push({
            path: `/goodsPool`,
          });
          break;
        // case 36:
        //   this.$router.push({
        //     path: `/billReview`,
        //   });
        //   break;
        // case 37:
        //   this.$router.push({
        //     path: `/drawBill`,
        //   });
        //   break;
        // case 38:
        //   this.$router.push({
        //     path: `/drawBillOver`,
        //   });
        //   break;
        // case 40:
        //   this.$router.push({
        //     path: `/orderList`,
        //   });
        //   break;
        // case 41:
        //   this.$router.push({
        //     path: `/corporateTransfer`,
        //   });
        //   break;
        // case 42:
        //   this.$router.push({
        //     path: `/waitDeliverGoods`,
        //   });
        //   break;
        
        // 认证相关菜单 - 根据环境动态判断ID
        case this.menuIdMap.certification:
          this.$router.push({
            path: `/certification`,
          });
          break;
        case this.menuIdMap.certificationSuccess:
          this.$router.push({
            path: `/certificationSuccess`,
          });
          break;
        case this.menuIdMap.certificationFail:
          this.$router.push({
            path: `/certificationFail`,
          });
          break;
        case this.menuIdMap.feedBack:
          this.$router.push({
            path: `/feedBack`,
          });
          break;
        case this.menuIdMap.certificationCancel:
          this.$router.push({
            path: `/certificationCancel`,
          });
          break;
      }
    },

    getMenuIcon(id) {
      let menuIconClass = "";
      switch (id) {
        case 28:
          menuIconClass = "el-icon-nine";
          break;
        case 29:
          menuIconClass = "el-icon-six";
          break;
        case 20:
          menuIconClass = "el-icon-orgu";
          break;
        case 21:
          menuIconClass = "el-icon-useru";
          break;
        case 6:
          menuIconClass = "el-icon-one";
          break;
        case 7:
          menuIconClass = "el-icon-two";
          break;
        case 10:
          menuIconClass = "el-icon-three";
          break;
        case 11:
          menuIconClass = "el-icon-four";
          break;
        case 12:
          menuIconClass = "el-icon-five";
          break;
        case 8:
          menuIconClass = "el-icon-six";
          break;
        case 24:
          menuIconClass = "el-icon-eight";
          break;
      }
      if (this.isClick == id) {
        menuIconClass = menuIconClass + "plus";
      }
      return menuIconClass;
    },
  },
  computed: mapState(["pageTitle", "menuList", "texts_status"]),
};
</script>
<style lang="scss" scoped>
.click {
  color: $menu-child !important;
}

@include icon-class;
.el-menu {
  margin-top: 15px;
  border-right: none;

  /deep/ .el-menu-item,
  /deep/ .el-submenu__title {
    height: 42px;
    line-height: 42px;
    padding-left: 41px !important;
    @include s-c-w(14, $menu-text, 500);
  }

  /deep/ .el-menu-item-group__title {
    padding: 0;
  }

  .el-submenu {
    .el-menu-item {
      padding-left: 68px !important;
      min-width: auto !important;
      @include s-c-w(12, $text-one, 500);
    }

    .el-menu-item-group__title {
      padding: 0 !important;
    }
  }
}
</style>
